const ModalComponent = class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        isVisible: false,
        isClosing: false,
      };
      this.handleModalKeyUp = this.handleModalKeyUp.bind(this);
      this.handleModalClick = this.handleModalClick.bind(this);
    }

    focusOnVisibleModal() {
      const visibleModal = document.querySelector('.overlay-background-react[style="display: block;"]');
      if (visibleModal) {
        visibleModal.focus();
      }
    }

    handleModalVisibility(show) {
      if (show) {
        this.setState({ isVisible: true }, () => {
          this.focusOnVisibleModal();
        });
      } else {
        this.setState({ isClosing: true });
        setTimeout(() => {
          this.props.closeModal();
          this.setState({
            isVisible: false,
            isClosing: false
          });
          this.focusOnVisibleModal();
        }, 120);
      }
    }

    handleModalKeyUp(e) {
      if (e.key === 'Escape' && !this.props.preventEscapeClose) { // TODO: Add overlay-no-close check when needed in React
        e.stopPropagation();
        this.handleModalVisibility(false);
      }
    }

    handleModalClick(e) {
      if (typeof(e.target.className) === 'string' && e.target.className.includes('overlay-cancel')) {
        e.stopPropagation();
        this.handleModalVisibility(false);
      }
    }

    componentDidMount() {
      this.handleModalVisibility(this.props.show);
    }

    componentDidUpdate(prevProps, prevState) {
      if (this.props.show !== prevProps.show) {
        this.handleModalVisibility(this.props.show);
      }
    }

    render() {
      const { show, closeModal, preventEscapeClose, children, className, id, ...otherProps } = this.props;
      return ReactDOM.createPortal(
        <div
          {...otherProps}
          id={id}
          className={`overlay-background overlay-background-react ${className || ''} ${this.state.isClosing ? 'overlay-closing' : ''}`}
          tabIndex="-1"
          role="dialog"
          style={{ display: show || this.state.isVisible ? 'block' : 'none' }}
          onClick={this.handleModalClick}
          onKeyUp={this.handleModalKeyUp}
        >
          {children}
        </div>,
        document.getElementById('modal-root')
      );
    }
}

window.ModalComponent = ModalComponent;
